import { Breakpoints, Theme } from "@mui/material/styles";

// export const breakpoints = {
//   sm: 20,
//   md: 30,
//   lg: 45,
//   xl: 60,
// };

// export const mediaQueries = (key: keyof typeof breakpoints) => {
//   return (style: TemplateStringsArray | String) =>
//     `@media (min-width: ${breakpoints[key]}em) { ${style} }`;
// };

// export const mediaQueries = (theme: Theme,key: keyof Breakpoints) => {
//   const { breakpoints } = theme;
//     return (style: TemplateStringsArray | String) =>
//     `@media (min-width: ${breakpoints[key]}) { ${style} }`;
// }

export type TypoSize = "smaller" | "small" | "medium" | "big" | "bigger";
export type TypoSizeProfile = {
  [K in TypoSize]: string;
};

export const sizes: TypoSizeProfile = {
  smaller: "0.9rem",
  small: "1.25rem",
  medium: "1.5rem",
  big: "1.75rem",
  bigger: "2rem",
};

export const mdSizes: TypoSizeProfile = {
  smaller: "0.5rem",
  small: "0.7rem",
  medium: "0.9rem",
  big: "1.1rem",
  bigger: "1.3rem",
};

export const lgSizes: TypoSizeProfile = {
  smaller: "0.7rem",
  small: "0.9rem",
  medium: "1.2rem",
  big: "1.5rem",
  bigger: "1.7rem",
};
export const xlSizes: TypoSizeProfile = {
  smaller: "1.125rem",
  small: "1.5rem",
  medium: "1.875rem",
  big: "2.25rem",
  bigger: "2.625rem",
};

export const getCurrentSizeProfile = (): TypoSizeProfile => {
  return sizes;
};

export const responsiveFontSize = (
  theme: Theme,
  size: TypoSize,
  reserveSpace?: boolean
) => {
  const { breakpoints } = theme;

  const build = (size: TypoSize) => ({
    [breakpoints.down("md")]: {
      fontSize: mdSizes[size],
      minHeight: reserveSpace ? `calc(${mdSizes[size]} * 1.5)` : 0,
    },
    [breakpoints.up("md")]: {
      fontSize: mdSizes[size],
      minHeight: reserveSpace ? `calc(${mdSizes[size]} * 1.5)` : 0,
    },
    [breakpoints.up("lg")]: {
      fontSize: lgSizes[size],
      minHeight: reserveSpace ? `calc(${lgSizes[size]} * 1.5)` : 0,
    },
    [breakpoints.up("xl")]: {
      fontSize: xlSizes[size],
      minHeight: reserveSpace ? `calc(${xlSizes[size]} * 1.5)` : 0,
    },
    [`${breakpoints.up("xl")} and (min-aspect-ratio: 20/9)`]: {
      fontSize: lgSizes[size],
      minHeight: reserveSpace ? `calc(${lgSizes[size]} * 1.5)` : 0,
    },
  });

  return build(size);
};

export const classDefinition = (size: TypoSize, reserveSpace: boolean) => {
  const currentSize = getCurrentSizeProfile()[size];
  return {
    fontSize: currentSize,
    minHeight: reserveSpace ? `calc(${currentSize} * 1.5)` : 0,
    minWidth: reserveSpace ? "1rem" : 0,
  };
};

export default { classDefinition, responsiveFontSize, getCurrentSizeProfile };
